export default "__VITE_ASSET__DMpAuADj__"